import { render, staticRenderFns } from "./CollectInfo.vue?vue&type=template&id=3196d03c&scoped=true&lang=html"
import script from "./CollectInfo.vue?vue&type=script&lang=js"
export * from "./CollectInfo.vue?vue&type=script&lang=js"
import style0 from "./CollectInfo.vue?vue&type=style&index=0&id=3196d03c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196d03c",
  null
  
)

export default component.exports